<template>
<div>
    <div class="row" v-if="$gate.isAdmin() || $gate.isReception() || $gate.isAccount() || $gate.isManager() || $gate.isSupervisor()">
        <div id="pdf" class="col-12">
            <div class="row mb-2">
                <div class="col-md-4"></div>
                <div class="col-md-4 d-flex justify-content-center">

                    <img src="./../Images/StepUp_logo.png" alt="StepUp" style="background-size: cover;width: auto; height: 150px;">
                </div>
                <div class="col-md-4"></div>
            </div>

             <div class="col-md-12 mt-5">
                 <h4 class="text-center">
                     <span v-if="vid === '34'">Spring Souk</span>
                     <span v-else-if="vid === '47'">Arabian Ranches III</span>
                 </h4>
                <h4 class="text-center">Posted Monthly Sales</h4>
             </div>

            <div class="col-md-12 mt-5">
                <table class="table table-bordered table-condensed">
                    <thead>
                        <tr>
                            <th>Sales Date From</th>
                            <th>Sales Date To</th>
                            <th>Transaction Count</th>
                            <th>Total Sales</th>
                            <th>Submitted By</th>
                            <th>Submitted Date</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="transaction in transactions" :key="transaction.id">
                            <td> {{transaction.sales_date_from}} </td>
                             <td> {{transaction.sales_date_to}} </td>
                            <th> {{transaction.transaction_count}}</th>
                            <td> {{Number(transaction.net_sales).toLocaleString()}} </td>
                            <td> {{transaction.submitted_by}} </td>
                            <td> {{transaction.created_at}} </td>
                        </tr>
                    </tbody>
                </table>
            </div>


            <div class="col-md-12">
                <div class="well"><h5>Transaction Summary</h5></div>
                <table class="table table-bordered table-responsive">
                    <tbody>
                        <tr>
                            <td>Total Transaction Count: </td>
                            <td>{{totalTransactionCount}}</td>
                        </tr>

                        <tr>
                            <td>Total Transaction Amount: </td>
                            <td>{{Number(totalTransactionAmount).toLocaleString()}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
        <div v-else>
            <notfound></notfound>
        </div>
</div>


</template>


<script>
import Swal from 'sweetalert2'
export default {

    data(){
        return {
            vid: 0,
            transactions:[],
        }
    },
    created(){
        this.vid = new URLSearchParams(window.location.search).get("vid");
        this.submittedMonthlySales();
    },
    methods: {
        submittedMonthlySales() {
            let self = this;
            axios
            .get('./api/Emaar/Monthly-Sales/posted?vid='+  new URLSearchParams(window.location.search).get("vid"))
            .then((result) => {
                this.transactions = result.data.transactions
            }).catch((err) => {
                console.log(err)
            });
        },
    },
    computed: {
        totalTransactionCount(){
            return  _.sumBy(this.transactions, function(o) { return o.transaction_count; });;
        },
        totalTransactionAmount(){
            var totalAmount = _.sumBy(this.transactions, function(o) { return Number(o.net_sales); });;
            return parseFloat(totalAmount).toFixed(2);
        }


    }
}
</script>





// WEBPACK FOOTER //
// resources/js/Emaar/PostedMonthlySales.vue